import { Permission } from '@cims-online/shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { IssueDispositionType } from '../../DispositionTypesContext/types'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { useDispositionTypesContext } from '../../DispositionTypesContext'
import { CreateFormItemsValues } from '../../components/CreateEditFormItems/types'
import { useCreateIssueDispositionTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useProjectContext } from 'context/ProjectContext'

export function useCreate(): CreateHeaderActionOptions<IssueDispositionType> {
  const { refetch } = useDispositionTypesContext()
  const { projectId } = useProjectContext()
  const [create] = useCreateIssueDispositionTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createIssueDispositionType: {
        dispositionType: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    permission: Permission.CreateIssueDispositionType,
    entity: 'Disposition Type',
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      onOk: async ({
        name,
        nonApplicableTypes,
        description,
      }: CreateFormItemsValues) => {
        await create({
          variables: {
            input: {
              name,
              projectId,
              description,
              nonApplicableIssueTypeIds: nonApplicableTypes?.map(({ value }) =>
                value.toString()
              ),
            },
          },
        })
        refetch()
      },
    },
  }
}
